/**
 * Formato único de fecha para toda la aplicación: dd-mm-aaaa.
 *
 * Las fechas llegan del backend como texto ('2026-09-09' o
 * '2026-09-09 14:30:00'). Se parte el texto en lugar de construir un Date
 * porque `new Date('2026-09-09')` se interpreta en UTC y, según la zona
 * horaria del navegador, muestra el día anterior.
 */
export const formatFecha = (valor?: string | Date | number | null): string => {
  if (valor === null || valor === undefined || valor === '') return '';

  if (typeof valor === 'string') {
    const iso = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      // Las fechas "vacías" heredadas se guardan como el inicio de la época.
      if (iso[0] <= '1970-01-02') return '';
      return `${iso[3]}-${iso[2]}-${iso[1]}`;
    }
    const local = valor.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (local) return `${local[1]}-${local[2]}-${local[3]}`;
  }

  const fecha = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(fecha.getTime())) return '';
  const dia = String(fecha.getDate()).padStart(2, '0');
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  return `${dia}-${mes}-${fecha.getFullYear()}`;
};

/** Igual que `formatFecha`, con un texto de reemplazo cuando no hay dato. */
export const formatFechaO = (valor: string | Date | number | null | undefined, alternativa: string): string =>
  formatFecha(valor) || alternativa;

/**
 * Una coordenada sin cargar se guarda como 0. En ese caso no se muestra, en
 * lugar de informar una posición en el golfo de Guinea.
 */
export const tieneCoordenada = (valor?: string | number | null): boolean => {
  if (valor === null || valor === undefined || valor === '') return false;
  const numero = Number(valor);
  return !Number.isNaN(numero) && numero !== 0;
};
